/**
 * 新增 编辑
 * @author wql
 * @description  新增/编辑
 * @Date  2020/9/28
 */
import React, { Component } from 'react';
import { Form } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm, WizClassifySelect, WizAuthority } from '../../../common'

let { WizAvatarUpload, ossFileUtils, WizFileUpload } = framework_tool

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert,
  WizTreeSelect
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

class SubjectForm extends Component {

  constructor(props) {
    super(props);
    let { initialValue } = props;
    this.state = {
      type: initialValue && initialValue.liveType ? initialValue.liveType : 1,
      wizAuthorityKey: 'wizAuthorityKey' //用于处理wizAuthority组件重置不生效问题
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
      this.clearWizCallBack = [];
  }


  /**上传校验 */
  _ossBeforeUpload(file) {
    let result = true;
    // if (file.type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') == -1) {
    //   Wizmessage.error('只能上传xlsx文件,请重新选择!');
    //   result = false;
    // }
    this.setState({
      fileId: undefined,
      file: file,
    }, () => {
      //要做的事情
    }
    )
    return result;
  }

  /** 上传的文件显示内容 */
  _fileChildren() {
    let icon = <WizIcon type="loading" style={{ fontSize: 14 }} />
    let fileName = ''
    if (this.state.file && this.state.file.fileOriginalName) {
      icon = <WizIcon type="paper-clip" />;
      fileName = this.state.file.fileOriginalName;
    } else if (this.state.file && this.state.file.name) {
      fileName = this.state.file.name;
    }
    //anticon anticon-loading
    return (
      <>
        <WizButton><WizIcon type="upload" /> 选择文件</WizButton>
        {
          this.state.file ?
            <div class=" ant-upload-list ant-upload-list-text">
              <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                <div class="ant-upload-list-item-info">
                  {icon}
                  <span class="ant-upload-list-item-name ant-upload-list-item-name-icon-count-2"> {fileName} </span>
                </div>
              </div>
              {/* <WizProgress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} status="active" percent={99.9} showInfo={false}/> */}
            </div> : <></>
        }
      </>
    )
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips} >
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const { getFieldDecorator } = this.props.form;
    let items = [
      <Item label="名称">
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入科目名称' }],
          initialValue: this.initialValue.name,
        })(<WizInput maxlength={30} placeholder='请输入科目名称,最多输入30个字' />)}
      </Item>,
      <Item label="分类">
        {getFieldDecorator('categoryId', {
          rules: [{ type: 'array' }, { required: true, message: '请选择科目分类' }],
          initialValue: this.initialValue.categoryId == null ? [] : [{key: this.initialValue.categoryId, title: this.initialValue.categoryName}],
        })(
          <WizClassifySelect
            apiProps={{ type: 10, state: 1 }}
            wizTreeSelectListProps={{
              itemProps: {
                icon: 'unordered-list',
                title: '科目分类',
                tips: '请勾选科目分类'
              },
              multiple: false,
              treeCheckable: false,
              checkable: false,
              showSelectList: true,
              treeProps: { checkStrictly: true }
            }}
            onClearWiz={this._onClearWiz.bind(this)} />
        )}
      </Item>,
      <Item label="类型" >
        {getFieldDecorator('type', {
          rules: [{ required: true, message: '请选择类型' }],
          initialValue: this.initialValue.type
        })(
          <WizSelect>
            <Option value={1}>必修</Option>
            <Option value={2}>选修</Option>
          </WizSelect>
        )}
      </Item>,
      <Item label="适用范围" >
        {getFieldDecorator('authCmd', {
          initialValue: this.initialValue.authInfo,
          rules: [{ required: true, message: '请选择直播受众' }],
        })(
          <WizAuthority
            key={this.state.wizAuthorityKey}
            mode={'Form'}
            // classname={'demo-authority'}
            keys={['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']}
          />
        )}
      </Item>
    ]
    return items
  }



  /**点播的数据 */
  // _onDeman() {
  //   const { getFieldDecorator } = this.props.form;
  //   return (
  //     <Item label="视频文件" >
  //       {getFieldDecorator('videoFile', {
  //         rules: [{ required: true, message: '请上传视频文件' }],
  //         initialValue: (this.initialValue && this.initialValue.videoFile) ? [
  //           ossFileUtils.getOssFile(
  //             this.initialValue.videoFile, this.initialValue.videoFileName, this.initialValue.videoFileMimeType, this.initialValue.videoFileSize, this.initialValue.videoFileUri,
  //           )
  //         ] : [],
  //       })(
  //         <WizFileUpload
  //           accept={'.mp4'}
  //           beforeUpload={this._ossBeforeUpload.bind(this)}
  //           children={this._fileChildren()}
  //           showUploadList={false}
  //           uploadType={'system'}
  //         />
  //       )}
  //     </Item>)
  // }

  /**直播的数据 */
  _liveBroadcast() {
    const { getFieldDecorator } = this.props.form;
 
    const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole"} })
    let items = [
      <Item label="状态" >
        {getFieldDecorator('state', {
          initialValue: this.initialValue.state != null ? this.initialValue.state : 1
        })(
          <WizRadio.Group>
            <WizRadio value={1}>有效</WizRadio>
            <WizRadio value={0}>无效</WizRadio>
          </WizRadio.Group>
        )}
      </Item>
    ];
    return items
  }

  /**
    * 拓展属性
    */
  _ext = () => {
    if (this.state.type === 3) {
      // return this._onDeman();
    } else if (this.state.type === 1 || this.state.type === 2) {
      return this._liveBroadcast();
    }
    return null;
  }

  _ext2() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Item label="介绍" >
          {getFieldDecorator('intro', {
            initialValue: this.initialValue.intro
          })(
            <WizInput.TextArea rows={4} maxLength={100} placeholder={'请输入介绍最多100字'} />
          )}
        </Item>
      </>
    )
  }


  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{ span: 12, offset: 6 }}>
        <WizRow>
          <WizCol span={24} style={{ textAlign: 'center' }}>
            <WizButton style={{ marginLeft: 20 }} title="保存" type="primary" htmlType="submit">保存</WizButton>
            <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>重置</WizButton>
          </WizCol>
        </WizRow>
      </Item>
    )
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let data = {};
        data.categoryId = values.categoryId[0].key;
        data.intro = values.intro;
        data.name = values.name;
        data.type = values.type;
        data.authCmd = values.authCmd;
        if (this.props.onSubmit) {
          this.props.onSubmit(data);
        }
      }
    });
  };

  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let type = this.initialValue && this.initialValue.type ? this.initialValue.type : undefined;
    this.setState({
      type: type,
      wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    const { title } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <WizCard>
        <WizForm
          key={this.props.formKey}
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {/*{this._ext()}*/}
          {this._ext2()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(SubjectForm);


